import { render, staticRenderFns } from "./RollingItemsDetails.vue?vue&type=template&id=22b9079d&scoped=true"
import script from "./RollingItemsDetails.vue?vue&type=script&lang=js"
export * from "./RollingItemsDetails.vue?vue&type=script&lang=js"
import style0 from "./RollingItemsDetails.vue?vue&type=style&index=0&id=22b9079d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b9079d",
  null
  
)

export default component.exports